export const APPEARANCES = {
  default: 'default',
  danger: 'danger',
  lightGrey: 'light-grey',
};
